import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-password-expiry-popup',
  templateUrl: './password-expiry-popup.component.html',
  styleUrls: ['./password-expiry-popup.component.css']
})
export class PasswordExpiryPopupComponent {
  @Input() daysRemaining: number = 0;
  @Output() changePassword = new EventEmitter<void>();
  @Output() remindLater = new EventEmitter<void>();

  onChangePassword() {
    this.changePassword.emit();
  }

  onRemindLater() {
    this.remindLater.emit();
  }
}